if (!customElements.get("swiper-slider")) {
  class SwiperSlider extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.slideContainer = this.querySelector("[data-swiper]:not([data-swiper-thumbs])");
      this.video = false;
      if (this.dataset.swiperVideo) {
        this.video = true;
      }
      this.slides = this.querySelectorAll("[data-swiper-slide]");
      this.isVideoSlider = this.hasAttribute('video-slider');
      this.sliderOptions = this.applyDefaultOptions(this.getSliderOptions());
      this.activeIndex = 0;
      this.initialized = false;
      if (this.dataset.swiperThumbs) {
        this.thumbnails = this.querySelector('[data-swiper-thumbs]');
      }
      if (this.dataset.customEvent) {
        this.attachCustomListeners(this.dataset.customEvent);
      }
      if (this.slideContainer && this.slides.length > 0) {
        document.addEventListener(
          "DOMContentLoaded",
          this.initializeSwiper.bind(this)
        );
        document.addEventListener(
          "shopify:section:load",
          this.initializeSwiper.bind(this)
        );
        document.addEventListener(
          "td:section-rendered",
          this.initializeSwiper.bind(this)
        );
        window.addEventListener("resize", this.handleResize.bind(this));

        this.addEventListener("go-to-slide", this.goToSlide.bind(this));

        this.addEventListener("update-variant-image", this.updateVariantImage.bind(this));
        
        this.addEventListener("update-slides", this.updateSlides.bind(this));
      } else {
        console.warn("SwiperSlider - Slider or Slides Not Found");
      }
    }

    attachCustomListeners(customEvent) {
      switch (customEvent) {
        case "swiper_event":
          document.addEventListener("swiper_event", this.updateSlides.bind(this));
          break;
      }
    }

    updateSlides(evt) {
      this.slider.appendSlide(evt.detail.slides);
      this.goToSlide(evt);
      if(this.slider.thumbs) {
        this.slider.thumbs.swiper.update();
      }
      this.slider.update();
    }

    updateVariantImage(evt) {
      const variantFeaturedImageId = evt.detail.id;
      const imageIds = this.querySelectorAll("[data-image-id]")

      if (imageIds) {
        imageIds.forEach(element => {
          let imageId = element.getAttribute("data-image-id")
          if (imageId == variantFeaturedImageId) {
            let index = element.getAttribute("data-position");
            if(index){
              this.slider.slideTo(index);
            } 
          }
        });        
      }
    }
  
    goToSlide(index) {
      if (this.slider) {
        if (index < 0 || index >= this.slider.slides.length) {
          console.warn("SwiperSlider - Invalid slide index in goToSlide method");
          return;
        }
        this.slider.slideTo(index, 1000, false);
        const slideVideo = this.slider.slides[this.slider.activeIndex].querySelector('video');
        if (slideVideo) {
          slideVideo.currentTime = 0;
        }
      } else {
        console.warn("SwiperSlider - Swiper not initialized in goToSlide method");
      }
    } 

    handleSlideMedia(prevSlide, currentSlide){
      if (currentSlide) {
        const currentSlideMedia = currentSlide.querySelector('video');
        if (currentSlideMedia) {
          currentSlideMedia.currentTime = 0;
          currentSlideMedia.play();
        }
      }
  
      if(prevSlide != undefined) {
        const prevSlideMedia = prevSlide.querySelector('video');
        if (prevSlideMedia) {
          prevSlideMedia.pause();
        }
      } 
    }

    applyDefaultOptions(options) {
      if (options.loop === undefined) {
        options.loop = true;
      }
      options.speed = 400;
      return options;
    }

    getSliderOptions() {
      try {
        return JSON.parse(this.dataset.swiperOptions);
      } catch (err) {
        console.log(err);
        return {};
      }
    }

    initializeSwiper() {
      if (window.Swiper && !this.initialized) {
        this.initialized = true;
        if(this.thumbnails) {
          this.setThumbnails()
        }
        if (this.video) {
          this.dispatchVideoEvent()
        }
        this.slider = new Swiper(this.slideContainer, this.sliderOptions);
        this.initializeSliderEventListeners();
        //add class to locked slider wrapper
        if (this.slider.isLocked) {
          this.classList.add('td-swiper-is-locked');
        }
      } else if (!window.Swiper) {
        console.warn("SwiperSlider - Swiper.js not found");
      }
    }
    dispatchVideoEvent() {
      const swiperElm = this;
      this.sliderOptions.on = {
      	slideChange: function () {
          swiperElm.dispatchEvent(new CustomEvent("swiperSlideChanged", {detail: {slide_id: this.activeIndex}, bubbles: true}));
        }
      }
    }

    handleResize(e) {
      if (this.slider) {
        setTimeout(() => {
          this.slider.updateSize();
        }, 300);
      }
    }

    setThumbnails() {
      const thumbsSlideContainer = this.thumbnails;
      const thumbOptions = JSON.parse(this.thumbnails.dataset.swiperOptions);
      const thumbnailsSlider = new Swiper(thumbsSlideContainer, thumbOptions);
      this.sliderOptions.thumbs = {swiper: thumbnailsSlider};
    }

    initializeSliderEventListeners() {

      if (this.slider) {
        this.slider.on('lock', () => {
          this.classList.add('td-swiper-is-locked');
        })
        this.slider.on('unlock', () => {
          this.classList.remove('td-swiper-is-locked');
        })
      }
      
      if(this.isVideoSlider && this.slider){ 
        this.slider.on('slideChange', () => {
          const prevSlide = this.slider.slides[this.slider.previousIndex];
          const currentSlide = this.slider.slides[this.slider.activeIndex];
          if (currentSlide) {
            currentSlide.removeAttribute("video-paused");
          }
          this.handleSlideMedia(prevSlide, currentSlide);
        }) 

        this.slides.forEach(slide => {
          slide.addEventListener('click', () => {
            const slideVideo = slide.querySelector('video');
            
            if (slideVideo) {
              if(slideVideo.paused){
                slide.removeAttribute('video-paused')
                slideVideo.play();
              }else{
                slide.setAttribute('video-paused',"")
                slideVideo.pause();
              }
            }
          })
        })
      }
    }
  }

  customElements.define("swiper-slider", SwiperSlider);
}